<script>
import { Bar } from 'vue-chartjs'
import { Line } from 'vue-chartjs'

export default {
  extends: Bar, Line,

  props: {
    chartData: {
      type: Object,
      default: null
    },
    isCurrency: Boolean,
    year: String,
    redirectOnClick: String
  },

  computed: {
    chartOptions() {
      return {
        onClick: this.redirectOnClick ? this.handleClick : () => { },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              borderDash: [2],
              borderDashOffset: [2],
              color: '#edf2f9'
            },
            ticks: {
              beginAtZero: true,
              precision: 0,
            }
          }]
        },
        interaction: {
          mode: 'index'
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              if (this.isCurrency) {
                const amount = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(tooltipItem.yLabel)
                const percentage = this.getTooltipPercentage(tooltipItem, data)

                if (percentage > 0 || percentage < 0) {
                  return `${amount}  ●  ${percentage}%`
                }

                return amount
              } else {
                return tooltipItem.yLabel
              }
            },
          }
        }
      }
    }
  },

  mounted() {
    if (this.chartData) {
      if (this.chartData.datasets) {
        this.chartData.datasets.forEach((d) => {
          if (d.data.length) {
            if (d.label.includes('prévisionnel')) {
              return
            }

            const avg = this.average(d.data, d.label)

            if (avg.value > 0) {
              this.chartData.datasets.push({
                label: `Moyenne ${d.label}`,
                data: Array(avg.dataLength).fill(avg.value.toFixed(0)),
                type: 'line',
                fill: false,
                backgroundColor: d.backgroundColor,
                borderColor: d.backgroundColor,
                borderDash: [6, 6],
                borderDashOffset: 0,
                hidden: true
              })
              // this.chartOptions.annotation.annotations.push({
              //   drawTime: 'afterDraw', // overrides annotation.drawTime if set
              //   id: d.label, // optional
              //   type: 'line',
              //   mode: 'horizontal',
              //   scaleID: 'y-axis-0',
              //   value: avg,
              //   borderColor: d.backgroundColor,
              //   borderDash: [6, 6],
              //   borderDashOffset: 0,
              //   borderWidth: 2,
              //   label: {
              //     fontSize: 10,
              //     position: 'center',
              //     backgroundColor: d.backgroundColor,
              //     content: `Moyenne ${d.label}: ${avg.toFixed(0)} ${this.isCurrency ? '€' : ''}`,
              //     enabled: false
              //   },
              //   onMouseenter(e) {
              //       if (this.options.label.enabled) {
              //         return
              //       }

              //       this.options.label.enabled = true

              //       this.chartInstance.update()
              //   },
              //   onMouseleave(e) {
              //     setTimeout(() => {
              //       this.options.label.enabled = false

              //       this.chartInstance.update()
              //     }, 2000)
              //   }
              // })
            }
          }
        })

        this.renderChart(this.chartData, this.chartOptions)
      }
    }
  },

  methods: {
    average(data, name) {
      const currentMonth = new Date().getMonth()

      if (name.includes('N-1')) {
        return {
          value: data.reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0) / data.length,
          dataLength: data.length
        }
      }

      // Not supported
      if (name.includes('prévisionnel')) {
        return {
          value: data.reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0) / (12 - currentMonth),
          dataLength: (12 - currentMonth)
        }
      }

      return{
        value: data.reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0) / currentMonth,
        dataLength: currentMonth
      }
    },
    handleClick(event, points) {
      const chart = this._data._chart

      const datapoint = chart.getElementAtEvent(event)[0];

      if (!datapoint) {
        return
      }

      const dataIndex = datapoint._index;
      const datasetIndex = datapoint._datasetIndex;

      if (this.chartData.datasets[datasetIndex]) {
        if (this.chartData.datasets[datasetIndex].data[dataIndex]) {

          const url = new URL(this.redirectOnClick)

          url.searchParams.append('year', this.year);
          url.searchParams.append('month', dataIndex + 1);

          if (datasetIndex === 1) {
            url.searchParams.append('type', 'goingout');
          } else {
            url.searchParams.append('type', 'entering');
          }

          window.location.replace(url.href);
        }
      }
    },

    getTooltipPercentage(tooltipItem, data) {
      const datasetIndex = tooltipItem.datasetIndex
      const dataIndex = tooltipItem.index
      const fromValue = tooltipItem.value
      let toValue = 0
      let result = 0

      if (data.datasets[datasetIndex].percentage) {
        if (data.datasets[datasetIndex].percentage === 'from') {
          let toDatasets = []

          data.datasets.map((k, v) => {
            if (k.percentage && k.percentage === 'to') {
              if (k.data[dataIndex] > 0) {
                toValue = k.data[dataIndex]
              }
            }
          })
        }

        if (data.datasets[datasetIndex].percentage === 'to') {
          let toDatasets = []

          data.datasets.map((k, v) => {
            if (k.percentage && k.percentage === 'from') {
              if (k.data[dataIndex] > 0) {
                toValue = k.data[dataIndex]
              }
            }
          })
        }
      }

      if (fromValue > 0 && toValue > 0) {
        result = fromValue - toValue / fromValue * 100
      }

      return parseInt((fromValue - toValue) / toValue * 100, 10)
    }
  }
}
</script>
